/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_TitleInputs */

const vi_order_settlement_title = /** @type {(inputs: Order_Settlement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận giao hàng`)
};

/**

* @param {Order_Settlement_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_title = /** @type {((inputs?: Order_Settlement_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_title(inputs)
});